import format from 'string-template';
import { StorageProcessState } from '../../../../../../../hooks/useStorage';
import { storagePaths, pathPlaceholder } from '../../../../../../../utils/firebasePaths';

export const MAX_ATTACHMENTS_COUNT = 5;

/**
 * Builds the files-to-add structure from attachment list for upload.
 * @param {Array<{ file: File, id: string }>} attachmentsToUpload
 * @returns {{ filesToAdd: Array, filesToAddById: Object }}
 */
export function buildFilesToAddFromAttachments(attachmentsToUpload) {
  const filesToAddById = attachmentsToUpload.reduce((acc, { file, id }) => {
    const lastDotIndex = file.name.lastIndexOf('.');
    acc[id] = {
      dataUrl: URL.createObjectURL(file),
      format: file.name.slice(lastDotIndex + 1),
      fileName: file.name.slice(0, lastDotIndex),
      fileType: file.type,
      fileId: id,
    };
    return acc;
  }, {});

  return {
    filesToAdd: Object.values(filesToAddById),
    filesToAddById,
  };
}

/**
 * @param {string} coachId
 * @returns {string} Storage path for comment attachments
 */
export function getCommentAttachmentsStoragePath(coachId) {
  return format(storagePaths.COACH_ANNOUNCEMENTS_COMMENTS_ATTACHMENTS, {
    [pathPlaceholder.COACH_ID]: coachId,
  });
}

/**
 * Splits upload results into successful and failed.
 * @param {Array} results - Results from uploadAttachments
 * @returns {{ uploadedAttachments: Array, failedFiles: Array }}
 */
export function processUploadResults(results) {
  const uploadedAttachments = [];
  const failedFiles = [];

  results.forEach((res) => {
    if (res.state === StorageProcessState.SUCCESS) {
      uploadedAttachments.push(res);
    } else {
      failedFiles.push(res);
    }
  });

  return { uploadedAttachments, failedFiles };
}
